import React, { Component } from "react";
import PropTypes from "prop-types";
import { dismissibleChild } from "./dismissible";

export default function dropdown(DropDown) {
  const Container = class extends Component {
    static propTypes = {
      close: PropTypes.func.isRequired
    };

    static childContextTypes = {
      close: PropTypes.func
    };

    getChildContext() {
      return { close: this.props.close };
    }

    render() {
      return <DropDown {...this.props} />;
    }
  };

  return dismissibleChild(Container);
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/dropdown.jsx